import React from 'react';
import { useTypedTranslation } from '@app/hooks';

export const SetUpDeviceMobile = () => {
    const { translation } = useTypedTranslation();

    return (
        <div className='manage-mfa-token__part manage-mfa-token__part-1'>
            <span>1.{' '}</span>
            <span>
                {translation('MOBILE_APP_INSTALL_STEP_1_PART_1')}
                <strong>{translation('MOBILE_APP_INSTALL_STEP_1_PART_2')}</strong>
                {translation('MOBILE_APP_INSTALL_STEP_1_PART_3')}
            </span>
        </div>
    );
};
